'use client';
import React from 'react';
import { CalendarCheck, MessageSquare, CheckCircle, Clock } from 'lucide-react';

const kpis = [
  {
    id: 'emp-kpi-active',
    label: 'Active bookings',
    value: '2',
    sub: 'Confirmed upcoming',
    icon: <CalendarCheck size={20} style={{ color: 'var(--primary)' }} />,
    bg: 'var(--orange-pale)',
  },
  {
    id: 'emp-kpi-messages',
    label: 'Unread messages',
    value: '3',
    sub: 'From 2 candidates',
    icon: <MessageSquare size={20} style={{ color: 'var(--navy)' }} />,
    bg: '#EEF2FF',
    alert: true,
  },
  {
    id: 'emp-kpi-completed',
    label: 'Completed bookings',
    value: '14',
    sub: 'All time',
    icon: <CheckCircle size={20} style={{ color: 'var(--success)' }} />,
    bg: 'var(--success-bg)',
  },
  {
    id: 'emp-kpi-review',
    label: 'Pending reviews',
    value: '1',
    sub: 'Awaiting your review',
    icon: <Clock size={20} style={{ color: 'var(--warning)' }} />,
    bg: 'var(--warning-bg)',
    alert: true,
  },
];

export default function EmployerKPICards() {
  return (
    <div className="grid grid-cols-2 xl:grid-cols-4 gap-4">
      {kpis?.map((kpi) => (
        <div key={kpi?.id} className="card p-5 relative" style={{ background: kpi?.bg }}>
          {kpi?.alert && (
            <span className="absolute top-3 right-3 w-2 h-2 rounded-full animate-pulse-soft" style={{ background: 'var(--primary)' }} />
          )}
          <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-white/70 mb-3">
            {kpi?.icon}
          </div>
          <div className="tabular-nums text-2xl font-extrabold mb-0.5" style={{ color: 'var(--navy)' }}>{kpi?.value}</div>
          <div className="text-xs font-semibold mb-0.5" style={{ color: 'var(--muted-foreground)' }}>{kpi?.label}</div>
          <div className="text-xs" style={{ color: 'var(--muted-foreground)' }}>{kpi?.sub}</div>
        </div>
      ))}
    </div>
  );
}